import { PromptType } from "../enum/prompt_type";
class VideoCallErrorModel {
    constructor({ promptType = PromptType.error, message = ''}) {
        this._promptType = promptType;
        this._message = message;
    }

    get promptType() {
        return this._promptType;
    }

    get message() {
        return this._message;
    }

    toJson() {
        return {
            promptType: this._promptType,
            message: this._message,
        }
    }
}

export default VideoCallErrorModel;